import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useGetAllInvoiceQuery } from "../../../Api/attoDeskApi";

const RedirectInvoiceEditToQuoteHistory: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError } = useGetAllInvoiceQuery({
    searchText: "",
    id: String(id || ""),
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
        <CircularProgress />
      </Box>
    );
  }

  const invoice: any = Array.isArray(data?.data) ? data?.data[0] : null;
  const workOrderId = invoice?.work_order_id;

  if (isError || !workOrderId) {
    return <Navigate to="/invoice/list" replace />;
  }

  return <Navigate to={`/quote-history/${workOrderId}`} replace />;
};

export default RedirectInvoiceEditToQuoteHistory;
